import "@/App.css";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";

import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Ribbon } from "@/components/Ribbon";
import { About } from "@/components/About";
import { Portfolio } from "@/components/Portfolio";
import { Services } from "@/components/Services";
import { Skills } from "@/components/Skills";
import { Process } from "@/components/Process";
import { Awards } from "@/components/Awards";
import { Gallery } from "@/components/Gallery";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  return (
    <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
      <div className="min-h-screen bg-[#0a0a0a] text-white antialiased">
        <div className="noise-overlay" aria-hidden="true" />
        <Header />
        <main>
          <Hero />
          <Ribbon />
          <About />
          <Portfolio />
          <Services />
          <Skills />
          <Process />
          <Awards />
          <Gallery />
          <Contact />
        </main>
        <Footer />
        <Toaster
          position="bottom-right"
          theme="dark"
          toastOptions={{
            style: {
              background: "#121212",
              border: "1px solid rgba(255,255,255,0.1)",
              color: "#f5f5f5",
            },
          }}
        />
      </div>
    </ReactLenis>
  );
}

export default App;
